import { useState, useEffect } from "react"
import { HexColorPicker } from "react-colorful";
import Sheet from 'react-modal-sheet';

export default function ColorSelectorModal(
    { 
        isColorSelectorModalOpen,
        onColorSelectorModalDismiss,
        initialColor,
        onColorSaveClick
    }
) {

    const [color, setColor] = useState(initialColor)

    useEffect(() => {
        setColor(initialColor)
    }, [initialColor])

    function onColorChange(event) {
        setColor(event.target.value)
    }

    return <Sheet
     isOpen={isColorSelectorModalOpen} onClose={() => {onColorSelectorModalDismiss()}} onOpenEnd={() => {}} detent="conten-height"
     disableDrag={true}
     >
        <Sheet.Container>
        <Sheet.Content className="bg-base-300">
        <Sheet.Scroller draggableAt="both">
        <div className="p-4 h-full">
        <div className="pb-8 pt-8 px-4">
            <HexColorPicker color={color ?? "#FDCF2B"} onChange={setColor} />
            <div className="flex gap-2 pt-4">
                <div className="form-control relative flex flex-row items-center gap-2">
                    <input className={`input input-bordered flex-1 rounded-md z-1`} value={color} placeholder={color} onChange={(event) => { setColor(event.target.value) }} />
                </div>
            </div>
        </div>
        <div className="modal-action bg-base-100 w-full px-4 py-4">
            <button className="btn btn-success text-success-content mr-2 normal-case" onClick={
                () => {
                    onColorSaveClick(color)
                }
                } >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="stroke-success-content" d="M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H9M8 20V14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14V20M8 20H16M16 20H18C19.1046 20 20 19.1046 20 18V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L16.5858 4.58579C16.2107 4.21071 15.702 4 15.1716 4H15M15 4V7C15 7.55228 14.5523 8 14 8H10C9.44772 8 9 7.55228 9 7V4M15 4H9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>    
                Save
            </button>

            <button className="btn btn-circle btn-soft" onClick={
                    () => {
                        onColorSelectorModalDismiss()
                    }
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
        </div>
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onColorSelectorModalDismiss()
        }}/>
    </Sheet>
}